import apiClient from 'src/utils/apiClient';

export interface AssociateProfile {
  readonly name: string;
  readonly alias: string;
  readonly location: string;
  readonly employeeId: string;
  readonly managersName: string;
  readonly managersAlias: string;
  readonly shift: string;
  readonly personId: string;
  readonly jobTitle: string;
  readonly totalAccommodatedDays?: number;
}

class AssociateProfileService {
  public async getAssociateProfile(alias: string, siteId: number) {
    if (!alias) {
      throw new Error('Alias is required');
    }
    return await apiClient.get<AssociateProfile>(`/associateProfile/${alias}?siteId=${siteId}`);
  }
}

export default new AssociateProfileService();
